import React from 'react';
import { Navigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import Loadable from 'utilities/Loadable';

const ProtectedRoute = ({ component: Component, ...args }) => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Component {...args} />;
};

export default ProtectedRoute;
